import React, { useMemo } from 'react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';

import { PartialPartnerRelationType, useFetchPartnerRelations } from 'hooks/useFetchPartnerRelations';
import ValidatedDropdown, { DropdownOption } from 'components/Common/ValidatedDropdown';
import { useFormikContext } from 'formik';
import ContactNote, { ContactNotePartner } from 'types/ContactNote';

const ContactNoteFormRelatedPartners = () => {
  const { techId } = useParams<{ techId: string }>();
  const { data: partnerRelations } = useFetchPartnerRelations(techId || '');
  const { t } = useTranslation();
  const { values } = useFormikContext<ContactNote>();
  const dropdownOptionsFromValues: DropdownOption[] = useMemo(
    () =>
      values.relatedPartners?.map((partner: ContactNotePartner) => {
        return {
          label: partner?.fullName,
          value: { partnerUId: partner.partnerUId },
        };
      }),
    [],
  );

  const relatedPartnerOptions: DropdownOption[] =
    partnerRelations
      ?.filter(
        //Filter inactive relations
        (relation: PartialPartnerRelationType) => relation.relationStatus === 'ACTIVE',
      )
      .map((relatedPartner: PartialPartnerRelationType) => {
        return {
          label: relatedPartner.fullName,
          value: { partnerUId: relatedPartner.hasPartner },
        };
      })
      .concat(dropdownOptionsFromValues)
      .filter(
        //Filter relations of the same partner
        (v, i, a) => a.findIndex((v2) => v2?.value?.partnerUId === v?.value?.partnerUId) === i,
      ) ?? [];

  const value = values.relatedPartners?.map((relatedPartner) => {
    return relatedPartnerOptions.find((partnerOption) => partnerOption.value.partnerUId === relatedPartner.partnerUId);
  });

  return (
    <ValidatedDropdown
      label={t('noteForm.attendeesClients', 'Attendees clients/prospects')}
      name="relatedPartners"
      isMultiChoice
      options={relatedPartnerOptions}
      value={value}
    />
  );
};

export default ContactNoteFormRelatedPartners;
